import gql from 'graphql-tag';
import createQuery from './createQuery';

export default createQuery(gql`
  mutation setKey($domain: String!, $key: String!, $data: JSON!, $readers: [String], $writers: [String]) {
    setKey(domain: $domain, key: $key, data: $data, readers: $readers, writers: $writers)
  }
`);
